import React from "react";
import MoreHorizRoundedIcon from "@mui/icons-material/MoreHorizRounded";
import styles from "./chathistory.module.css";

export interface ChatItem {
  id: string;
  title: string;
  timestamp: string;
  displayTimestamp?: string;
  isDeleting?: boolean;
}

interface ListItemProps {
  item: ChatItem;
  handleClickMore: (
    itemId: string,
    event: React.MouseEvent<HTMLButtonElement>
  ) => void;
  handleClickNavigate?: (item: ChatItem) => void;
}

const ListItem = ({
  item,
  handleClickMore,
  handleClickNavigate,
}: ListItemProps) => {
  return (
    <div
      className={styles.itemContainer}
      onClick={() => handleClickNavigate?.(item)}
    >
      <div className={styles.itemContent}>
        <h4>
          <span>{item.title}</span>
        </h4>
        {item.displayTimestamp && (
          <p className={styles.timestamp}>{item.displayTimestamp}</p>
        )}
      </div>
      <button
        aria-label="More options"
        title="More"
        onClick={(e) => {
          e.stopPropagation();
          handleClickMore(item.id, e);
        }}
        className={styles.moreButton}
        disabled={item.isDeleting}
      >
        <MoreHorizRoundedIcon />
      </button>
    </div>
  );
};

export default ListItem;
